module.exports = __webpack_public_path__ + "static/img/MS01.ae1dbfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/MS01.jpg
// module id = P/Yi
// module chunks = 9